import { render } from "./index.vue?vue&type=template&id=b5fa4f1a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b5fa4f1a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b5fa4f1a"

export default script